/* eslint-disable max-len */
import React from 'react';
// template components
import ProductCard from '@nmx/template/dist/componentLibrary/modules/ProductCard';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// styles
import { ColStyled } from './styles';

export default ({
  data,
  id,
}) => (
  <SectionContainer
    className='nmx-no-print'
    id={id}
    backgroundVariant='lightA'
    themeType='lightTheme'
    moduleName='product-callout-grouping-module'
    moduleVariation='B'>
    <Row align='center'>
      <Typography
        component='h2'
        nextElement='graphic'>
        Explore our impact in <WidowBlock>other areas</WidowBlock>
      </Typography>
    </Row>
    <Row>
      <ColStyled
        medium={6}
        large={5}
        largeOffset={1}
        xlarge={4}
        xlargeOffset={2}>
        <ProductCard
          backgroundVariant='lightB'
          condensed
          cardId={data.card1.id}
          cardHeading={data.card1.title}
          linkUrl={data.card1.link}
        />
      </ColStyled>
      <ColStyled
        medium={6}
        large={5}
        xlarge={4}>
        <ProductCard
          backgroundVariant='lightB'
          condensed
          cardId={data.card2.id}
          cardHeading={data.card2.title}
          linkUrl={data.card2.link}
        />
      </ColStyled>
    </Row>
    <Row>
      <ColStyled
        medium={6}
        large={5}
        largeOffset={1}
        xlarge={4}
        xlargeOffset={2}
        disableBottomPadding>
        <ProductCard
          backgroundVariant='lightB'
          condensed
          cardId={data.card3.id}
          cardHeading={data.card3.title}
          linkUrl={data.card3.link}
        />
      </ColStyled>
      <ColStyled
        medium={6}
        large={5}
        xlarge={4}
        disableBottomPadding
        lastItem>
        <ProductCard
          backgroundVariant='lightB'
          condensed
          cardId={data.card4.id}
          cardHeading={data.card4.title}
          linkUrl={data.card4.link}
        />
      </ColStyled>
    </Row>
  </SectionContainer>
);

